module.exports = __webpack_public_path__ + "media/images/lb/372-98a9c2614643fa2a12cbca396f24becb.svg";